// @core/api/endpoints/context/update_tenant_context_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTenantContextConfigRequest,
  UpdateTenantContextConfigResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Update tenant context configuration
 * Updates the tenant-level Context Panel configuration. Changes take effect for all tenant users after cache invalidation (< 1 min).
 */
export async function UpdateTenantContextConfig(
  data: UpdateTenantContextConfigRequest,
  options?: RequestOptions
): Promise<UpdateTenantContextConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/context/config/tenant`;
  const requestOptions = options;
  return client.put<UpdateTenantContextConfigResponse>(requestPath, data, requestOptions);
}
